import api from '../services/api';

// Message shown when sending a chat message fails without a usable reply from our server
// (no connection, proxy error page, etc.). Server-provided errors are shown as-is elsewhere.
export function describeSendError(error, stage) {
  if (!error?.response) {
    return stage === 'upload'
      ? "Couldn't upload your file — check your internet connection and tap Send again."
      : "Couldn't reach the server — check your internet connection and tap Send again.";
  }
  return `Something went wrong (error ${error.response.status}). Please tap Send again.`;
}

// Tell the server about a send failure that left no trace in its own logs.
export function reportSendError(error, stage, extra = {}) {
  api.post('/client-error', {
    stage,
    status: error?.response?.status ?? null,
    code: error?.code || '',
    message: error?.message || '',
    online: typeof navigator !== 'undefined' ? navigator.onLine : null,
    ...extra,
  }).catch(() => {});
}
